import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

import Banner from '../ui/Banner';
import { isSelected } from '../../helpers/ui';
import { Html5Entities } from 'html-entities';
const htmlEntities = new Html5Entities();

const FlatList = ({ filteredList, addRemoveItem, checkForEmptyList }) => {
	const selectedList = useSelector(state => state.selectedList);

	return (
		<div>
			<Banner />
			<div id="tree_container" className="flat-list">
				<ul>
					{filteredList && Object.keys(filteredList).map(x => {
						const acctId = filteredList[x][0];

						// An item is checked if the account is in the list of selected accounts
						const isChecked = isSelected({acctId, selectedList});
						const checkboxClass = isChecked ? 'checked' : '';

						return (
							<li key={x}>
								<span className='node'>
									<div className={`checkbox ${checkboxClass}`}
										data-acct-id={acctId}
										onClick={e =>{
											// Toggle checkbox
											e.stopPropagation();
											checkForEmptyList([acctId], !isChecked);
											addRemoveItem([acctId], !isChecked);
										}}>
										<span></span>
									</div>
									<span className='dealer-name'>{htmlEntities.decode(filteredList[x][1])
										+ ' ' + String.raw`(${htmlEntities.decode(filteredList[x][0])})`}</span>
								</span>
							</li>
						)})}
				</ul>
			</div>
		</div>
	);
};

FlatList.propTypes = {
	addRemoveItem: PropTypes.func,
	checkForEmptyList: PropTypes.func,
	filteredList: PropTypes.array,
	tree: PropTypes.shape({}),
};

export default FlatList;